import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';


const OfficeTel = (props) => {
  return (
    <FormGroup controlId="officeTel">
      <Col componentClass={ControlLabel} sm={5}>
        Office Tel.
      </Col>
    <Col sm={7}>
      <FormControl type="text" value={props.officeTel} onChange={props.handleChangeOfficeTel}
        autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

OfficeTel.propTypes = {
  officeTel: PropTypes.string,
  handleChangeOfficeTel: PropTypes.func
};

export default OfficeTel;



// WEBPACK FOOTER //
// ./src/app/components/officeTel/OfficeTel.js